// src/components/store/sections/testimonials/TestimonialV9CyberverifiedFuchsiaGlow.tsx
"use client";

import React from "react";
import DynamicTestimonialVariant from "./DynamicTestimonialVariant";

export default function TestimonialV9CyberverifiedFuchsiaGlow(props: any) {
  return (
    <DynamicTestimonialVariant
      variantNumber={9}
      archKey="cyber_verified"
      archLabel="Cyber Neon Verified"
      palName="FuchsiaGlow"
      grad="from-fuchsia-500 via-pink-500 to-purple-700"
      lightBg="bg-fuchsia-50"
      textCol="text-fuchsia-700"
      borderCol="border-fuchsia-200"
      btnCls="bg-fuchsia-600 hover:bg-fuchsia-700"
      hexCol="#d946ef"
      {...props}
    />
  );
}
